export const GET_SHOPS = "GET_SHOPS";
export const GET_SHOPS_SUCCESS = "GET_SHOPS_SUCCESS";
export const GET_SHOPS_FAIL = "GET_SHOPS_FAIL";

export const getShops = () => ({
  type: GET_SHOPS
})